import React, { createRef, Fragment } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './App';

import { COLORS } from './shared/Theme';

import { SnackbarProvider, useSnackbar } from 'notistack';
import { Button, makeStyles, ThemeProvider } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';
import axios from 'axios';
import { SNACKBAR_TIME } from './request/values';
import { SnackbarCloseButton } from './components/SnackBar';
import { RNListener } from './components/RNListener';

axios.defaults.withCredentials = true;

declare module '@material-ui/core/styles/createTypography' {
	interface Typography {
		login_blue: React.CSSProperties;
		login_orange: React.CSSProperties;
		water_blue: React.CSSProperties;
		desc: React.CSSProperties;
	}

	interface TypographyOptions {
		login_blue: React.CSSProperties;
		login_orange: React.CSSProperties;
		water_blue: React.CSSProperties;
		desc: React.CSSProperties;
	}
}

declare module '@material-ui/core/styles/createPalette' {
	// allow configuration using `createMuiTheme`
	interface Palette {
		water_blue: PaletteColor;
		pumpkin: PaletteColor;
		white: PaletteColor;
		pink: PaletteColor;
		blue_grey: PaletteColor;
		slate_grey: PaletteColor;
		charcoal_grey: PaletteColor;
	}
	interface PaletteOptions {
		water_blue?: PaletteColorOptions;
		pumpkin?: PaletteColorOptions;
		white?: PaletteColorOptions;
		pink?: PaletteColorOptions;
		blue_grey?: PaletteColorOptions;
		slate_grey?: PaletteColorOptions;
		charcoal_grey?: PaletteColorOptions;
	}
}

declare module '@material-ui/core/Typography/Typography' {
	interface TypographyPropsVariantOverrides {
		login_blue: true;
		login_orange: true;
		color: true;
		desc: true;
	}
}

const theme = createTheme({
	palette: {
		water_blue: {
			main: '#1291d9',
		},
		pumpkin: {
			main: '#ef7d00',
		},
		white: {
			main: '#ffffff',
		},
		pink: {
			main: '#e4e4e4',
		},
		blue_grey: {
			main: '#ced4da',
		},
		slate_grey: {
			main: '#525a67',
		},
		charcoal_grey: {
			main: '#313840',
		},
	},
	breakpoints: {
		values: {
			xs: 0,
			sm: 600,
			md: 850,
			lg: 1024,
			xl: 1920,
		},
	},
	typography: {
		login_blue: {
			fontSize: 30,
			// color : `${COLORS.WATER_BLUE}`
		},
		login_orange: {
			fontSize: 30,
			color: `${COLORS.PUMPKIN}`,
		},
		water_blue: {
			fontSize: 30,
			color: `${COLORS.PUMPKIN}`,
		},
		desc: {
			fontFamily: 'NanumR',
			color: `${COLORS.BROWNISH_GREY}`,
			fontSize: 14,
		},
		h6: {
			fontFamily: 'NanumR',
			fontWeight: 'bold',
			fontSize: '7vw',
			'@media (min-width:748px)': {
				fontSize: '18px',
			},
		},
		h5: {
			fontFamily: 'NanumR',
			fontSize: '6.5vw',
			'@media (min-width:748px)': {
				fontSize: '18px',
			},
		},
		h4: {
			fontFamily: 'NanumR',
			fontSize: '5vw',
			lineHeight: '1.76',
			'@media (min-width:748px)': {
				fontSize: '20px',
			},
		},
		h3: {
			fontFamily: 'NanumR',
			fontSize: '4vw',
			color: '#ffffff',
			'@media (min-width:748px)': {
				fontSize: '22px',
			},
		},
		h2: {
			fontFamily: 'NanumR',
			fontSize: '3.75vw',
			'@media (min-width:748px)': {
				fontSize: '24px',
			},
		},
		h1: {
			fontFamily: 'NanumR',
			color: `${COLORS.BROWNISH_GREY}`,
			fontSize: '3.2vw',
			lineHeight: 1.8,
			'@media (min-width:748px)': {
				fontSize: '26px',
			},
		},
		subtitle1: {
			fontFamily: 'NanumB',
			fontWeight: 'bold',
			fontSize: '4vw',
			'@media (min-width:748px)': {
				fontSize: '22px',
			},
		},
		subtitle2: {
			fontFamily: 'NanumB',
			fontWeight: 'bold',
			fontSize: '3.5vw',
			'@media (min-width:748px)': {
				fontSize: '20px',
			},
		},
		// subtitle3: {
		//     fontFamily: 'NanumB',
		//     fontWeight: 'bold',
		//     fontSize: '3.25vw',
		//     '@media (min-width:748px)': {
		//         fontSize: '18px',
		//     },
		// },
		body1: {
			fontSize: '3vw',
			'@media (min-width:748px)': {
				fontSize: '18px',
			},
		},
		body2: {
			fontSize: '2.75vw',
			'@media (min-width:748px)': {
				fontSize: '16px',
			},
		},
	},
});

const styles = {
	base: {
		fontSize: '2.75vw',
	},
	backStyle: {
		backgroundColor: 'white',
	},
};

declare global {
	interface Window {
		ReactNativeWebView: {
			postMessage: (message: string) => void;
		};
	}
}

ReactDOM.render(
	// <React.StrictMode>
	<ThemeProvider theme={theme}>
		<RNListener />
	</ThemeProvider>,
	// </React.StrictMode>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
